import React from 'react'
import PropTypes from 'prop-types'
import { useWillPipe } from '@morningtrain/react-helpers'
import { useOperations, useResource } from '../hooks'
import useParameters from '../hooks/use-parameters'
import set from 'lodash/set'

function ExecuteOperationOnPipe (props) {
  const resource = useResource()
  const operations = useOperations()

  const namespace = props.namespace || ((resource && resource.namespace) ? resource.namespace : null)
  const resourceName = props.resourceName || ((resource && resource.slug) ? resource.slug : null)
  const { operationName } = props

  const operation = operations.get(namespace, resourceName, operationName, props.operationContext)

  const parameters = useParameters(props.routeParameters)

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      if (!operation) {
        reject('Attempted to pipe an operation execute, but the requested operation was falsy')
      }

      const dataResolver = (typeof props.data === 'function') ? props.data(payload) : (props.data)

      Promise.resolve(dataResolver)
        .then(data => {
          operation.execute(parameters, data || {})
            .then((rsp) => {
              set(payload, 'responses.' + (props.payloadResponseKey || operationName), rsp)

              resolve(payload)
            })
            .catch((err) => {
              reject(err)
            })
        })
        .catch(err => {
          reject(err)
        })
    })
  }, [props.data, parameters, props.payloadResponseKey, operationName])

  return null
}

ExecuteOperationOnPipe.defaultProps = {
  namespace: null,
  resourceName: null,
  operationName: null,
  operationContext: null,
  payloadResponseKey: null,
  data: {},
  routeParameters: {}
}

ExecuteOperationOnPipe.propTypes = {
  namespace: PropTypes.string,
  resourceName: PropTypes.string,
  operationName: PropTypes.string.isRequired,
  operationContext: PropTypes.object,
  payloadResponseKey: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  routeParameters: PropTypes.object
}

export default ExecuteOperationOnPipe
